module.exports = __webpack_public_path__ + "9a38bf241f28b8198d68a5e751683f42.png";